export default "https://assets-v2.scaler.com/packs/images/gift.8ea95c.svg";